export default {"src":"/_next/static/media/iconBack.b5b913ce.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};